
import { getToken,removeToken} from '@/utils/auth'
import {userProfile} from '@/api/index'

const state = {
    token: getToken(),
    userName: '',
    userInfo:null,
    mes:JSON.parse(localStorage.getItem('mes')) ,
    userProfile:null,


}

const mutations = {
    set_user_info: (state, response) => {
        state.userInfo =response && response.data? response.data:response
        state.userProfile = response

    },
        set_user_token: (state, userInfo) => {
        state.token = userInfo.token
    },


    set_user_userName: (state, userName) => {
        state.userName = userName
    },
        set_user_mes: (state, data) => {
        localStorage.setItem('mes', JSON.stringify(data));
        state.mes = data
    },

}
 
const actions = {
    updateLogoutData({commit}, data) {
         commit('set_user_userName', '')
            commit('set_user_info', null)
            removeToken()
            sessionStorage.clear();

    },
    // async getUserInfo({commit}, params) {
    //     let resp = await userProfile(params);
    //     const data = resp.data;
        
    //     if(resp.code === 200) {
    //         commit('set_user_userName', data.userName)
    //         commit('set_user_info', data)
    //     }    
    // },



  getUserInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      userProfile().then(response => {
        if(response.code === 200) {
        const data = response.data;

            commit('set_user_userName', data.userName)
            commit('set_user_info', response)
        } 
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

}
export default {
  state,
  mutations,
  actions
}